'use es6';

import Visit from 'customer-data-objects/visit/VisitRecord';
import PropTypes from 'prop-types';
const VisitType = PropTypes.instanceOf(Visit);
export default VisitType;